import { render, staticRenderFns } from "./msgBoxTemplate.vue?vue&type=template&id=25d3bca7&scoped=true&"
import script from "./msgBoxTemplate.vue?vue&type=script&lang=js&"
export * from "./msgBoxTemplate.vue?vue&type=script&lang=js&"
import style0 from "./msgBoxTemplate.vue?vue&type=style&index=0&id=25d3bca7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d3bca7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VBtn,VCard,VIcon,VOverlay})
